import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {LocalPreferenceType} from '@toolify/client/src/stores/LocalPreferenceStore/enum/LocalPreferenceType'
import {useLocalPreferenceStore} from '@toolify/client/src/stores/LocalPreferenceStore/useLocalPreferenceStore'
import {useResourceItemStore} from '@toolify/client/src/stores/ResourceItemStore/useResourceItemStore'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {saveLastVisitedDatabaseId} from '@toolify/client/src/modules/resources/utils/lastVisitedDatabase'

export function saveLastVisitedResourceRouterHook(pinia: Pinia) {
  return async function saveLastVisitedResourceRouterHookImpl(to: RouteLocationNormalized) {
    const workspaceName = to.params.workspaceName as string
    if(!workspaceName) {
      return
    }

    const routeResource = to.meta.determineResource?.(to) ?? null
    if(!routeResource) {
      return
    }

    const resourceItemStore = useResourceItemStore(pinia)
    const localPreferenceStore = useLocalPreferenceStore(pinia)
    const resourceValue = `${routeResource.resourceType}:${routeResource.resourceId}`
    await localPreferenceStore.set(LocalPreferenceType.LastVisitedResource, resourceValue, workspaceName)
    // Remembered on its own as well, so the pages that come after a database - a dashboard picking
    // the database a new widget should show, above all - can still tell which one it was.
    if(routeResource.resourceType === ResourceType.Database) {
      await saveLastVisitedDatabaseId(localPreferenceStore, workspaceName, routeResource.resourceId)
    }
    const resourceItem = resourceItemStore.resourceItems?.find(
      (item) => item.resourceEntity.resourceId === routeResource.resourceId && item.resourceEntity.resourceType === routeResource.resourceType,
    )
    if(resourceItem?.resourceSpaceId) {
      await localPreferenceStore.set(LocalPreferenceType.LastVisitedResourceBySpaceId, resourceValue, resourceItem.resourceSpaceId)
    }
  }
}
